import useLatest from "@-/com.npmjs.use-latest";
import { useMapPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.learn.map.navigator";
import { useCallback } from "react";
import { useLearnMapModeSelector } from "#use-learn-map-mode";

/**
 * Opens Learn's map from a press: the cards start leaving at once and the map's route follows
 * their slide (`switchMode`). Outside `LearnLayout` (a surface rendered on its own) it only pushes
 * the route.
 */
export function useOpenLearnMap(): () => void {
  const mapPageNavigator = useMapPageNavigator();
  const mapPageNavigatorRef = useLatest(mapPageNavigator);
  const switchMode = useLearnMapModeSelector((mode) => mode.switchMode);
  return useCallback(() => {
    const open = () => mapPageNavigatorRef.current.push.mutate();
    if (switchMode === undefined) {
      open();
    } else {
      switchMode(true, open);
    }
  }, [mapPageNavigatorRef, switchMode]);
}
